import { render, staticRenderFns } from "./FormProgramsPartnerships.vue?vue&type=template&id=9d9fc560&scoped=true&"
import script from "./FormProgramsPartnerships.vue?vue&type=script&lang=js&"
export * from "./FormProgramsPartnerships.vue?vue&type=script&lang=js&"
import style0 from "./FormProgramsPartnerships.vue?vue&type=style&index=0&id=9d9fc560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9fc560",
  null
  
)

export default component.exports